<template>
  <div id="Representative">
    <div class="card-wrap btn-ct">
      <img src="./img/Representative.jpg" alt="" class="card">
      <div class="builder hcb" title="胡昌炳" @click="showCard('hcb')"/>
      <div class="builder mxl" title="马学利" @click="showCard('mxl')"/>
      <div class="builder xcy" title="谢成远" @click="showCard('xcy')"/>
      <div class="builder ljh" title="罗锦鸿" @click="showCard('ljh')"/>
      <div class="builder yqh" title="源秋华"/>
      <div class="builder ljw" title="李竞伟"/>
      <div class="builder zjw" title="张劲文" @click="showCard('zjw')"/>
      <div class="builder sqk" title="苏权科" @click="showCard('sqk')"/>
      <div class="builder zyl" title="朱永灵" @click="showCard('zyl')"/>
      <div class="builder lm" title="林鸣" @click="showCard('lm')"/>
      <div class="builder mfc" title="孟凡超" @click="showCard('mfc')"/>
      <div class="builder csz" title="陈韶章" @click="showCard('csz')"/>
      <div class="builder tgs" title="谭国顺" @click="showCard('tgs')"/>
      <div class="builder zq" title="郑强" @click="showCard('zq')"/>
      <div class="builder cjf" title="蔡俊福" @click="showCard('cjf')"/>

      <div class="builder gya" title="管延安" @click="showCard('gya')"/>
      <div class="builder zbl" title="张宝兰" @click="showCard('zbl')"/>
      <div class="builder zbl" title="张宝兰" @click="showCard('zbl')"/>
      <div class="builder fjh" title="樊建华" @click="showCard('fjh')"/>
      <div class="builder jxx" title="江晓霞" @click="showCard('jxx')"/>
      <div class="builder cll" title="陈礼黎" @click="showCard('cll')"/>
      <div class="builder sq" title="施强" @click="showCard('sq')"/>
    </div>
    <template v-if="builder">
      <card :builder="builder" @close="builder = ''"/>
      <guide-button class="btn-rt" @click="builder = ''">继续</guide-button>
    </template>
    <template v-else>
      <guide-button class="btn-lt" @click="$router.push('/TitlePage/03')">返回</guide-button>
      <guide-button class="btn-rt" @click="$router.push('/Part04/Portrait')">继续</guide-button>
    </template>
  </div>
</template>

<script>
import Card from './Card'

export default {
  name: 'Representative',
  components: {
    Card,
  },
  data () {
    return {
      builder: '',
    }
  },
  methods: {
    showCard (builder) {
      this.builder = builder
    },
  },
}
</script>

<style lang="scss" scoped>
#Representative {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .card-wrap {
    .card {
      width: 13rem;
      height: 7rem;
      border-radius: 0.3rem;
    }
    & > .builder {
      position: absolute;
      cursor: pointer;
      // background-color: #eeeeee;
    }
    .hcb { // 胡昌炳
      width: 1rem;
      height: 3.7rem;
      left: 0.8rem;
      top: 3.3rem;
    }
    .mxl { // 马学利
      width: 1rem;
      height: 3.5rem;
      left: 1.8rem;
      top: 3.2rem;
    }
    .xcy { // 谢成远
      width: 0.8rem;
      height: 3.3rem;
      left: 2.8rem;
      top: 3.2rem;
    }
    .ljh { // 罗锦鸿
      width: 0.7rem;
      height: 3.3rem;
      left: 3.6rem;
      top: 3.2rem;
    }
    .yqh { // 源秋华
      width: 0.6rem;
      height: 3.3rem;
      left: 4.25rem;
      top: 3.1rem;
    }
    .ljw { // 李竞伟
      width: 0.7rem;
      height: 1.6rem;
      left: 4.88rem;
      top: 2.8rem;
    }
    .zjw { // 张劲文
      width: 0.8rem;
      height: 1.6rem;
      left: 5.5rem;
      top: 2.8rem;
    }
    .sqk { // 苏权科
      width: 0.8rem;
      height: 1.5rem;
      left: 6.3rem;
      top: 2.9rem;
    }
    .zyl { // 朱永灵
      width: 0.8rem;
      height: 1.4rem;
      left: 7.1rem;
      top: 3rem;
    }
    .lm { // 林鸣
      width: 0.8rem;
      height: 1.50rem;
      left: 7.8rem;
      top: 2.9rem;
    }
    .mfc { // 孟凡超
      width: 0.9rem;
      height: 1.4rem;
      left: 8.45rem;
      top: 3rem;
    }
    .csz { // 陈韶章
      width: 0.8rem;
      height: 1.4rem;
      left: 9.35rem;
      top: 2.9rem;
    }
    .tgs { // 谭国顺
      width: 1rem;
      height: 3.5rem;
      left: 10.2rem;
      top: 2.9rem;
    }
    .zq { // 郑强
      width: 0.9rem;
      height: 3.5rem;
      left: 11.2rem;
      top: 3rem;
    }
    .cjf { // 蔡俊福
      width: 1rem;
      height: 3.7rem;
      left: 12.1rem;
      top: 3.2rem;
    }

    .gya { // 管延安
      width: 0.9rem;
      height: 2rem;
      left: 4.8rem;
      top: 4.4rem;
    }
    .zbl { // 张宝兰
      width: 0.8rem;
      height: 2rem;
      left: 5.8rem;
      top: 4.4rem;
    }
    .fjh { // 樊建华
      width: 0.75rem;
      height: 2rem;
      left: 6.65rem;
      top: 4.4rem;
    }
    .jxx { // 江晓霞
      width: 0.7rem;
      height: 2rem;
      left: 7.4rem;
      top: 4.4rem;
    }
    .cll { // 陈礼黎
      width: 0.75rem;
      height: 2.1rem;
      left: 8.1rem;
      top: 4.3rem;
    }
    .sq { // 施强
      width: 1rem;
      height: 2.1rem;
      left: 8.9rem;
      top: 4.3rem;
    }
  }
}
</style>
